import { Pipe, PipeTransform } from '@angular/core';
import { MultiSelectOption } from '../components/multi-select/multi-select.component';

@Pipe({
  name: 'idsToMultiSelectOptions',
})
export class IdsToMultiSelectOptionsPipe implements PipeTransform {
  public transform(strings: string[], options: MultiSelectOption[]): MultiSelectOption[] {
    return options.filter((option) => Array.isArray(strings) && strings.includes(option.id));
  }
}
